import { render, staticRenderFns } from "./TableCuadro8.vue?vue&type=template&id=253f3746&scoped=true&"
import script from "./TableCuadro8.vue?vue&type=script&lang=js&"
export * from "./TableCuadro8.vue?vue&type=script&lang=js&"
import style0 from "./TableCuadro8.vue?vue&type=style&index=0&id=253f3746&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253f3746",
  null
  
)

export default component.exports